module.exports = __webpack_public_path__ + "static/media/edit.390770ea.svg";